import { Action } from '@ngrx/store';
import { IDisplayResultValue } from '../../models/display-result.model';

export enum ProductActionTypes {
  SetProductsResults = '[Products] SetProductResults',
  SetSelectedProductItem = '[Products] SetSelectedProductItem',
  GetAllUserProducts = '[Products] GetAllUserProducts'
}

export class SetProductsResults implements Action {
  readonly type = ProductActionTypes.SetProductsResults;
  constructor(public payload: { results: IDisplayResultValue[] }) { }
}

export class GetAllUserProducts implements Action {
  readonly type = ProductActionTypes.GetAllUserProducts;
  constructor() {}
}

export class SetSelectedProductItem implements Action {
  readonly type = ProductActionTypes.SetSelectedProductItem;
  constructor(public payload: { product: IDisplayResultValue}) {
  }
}



export type ProductActions = SetSelectedProductItem | SetProductsResults | GetAllUserProducts;
